import {
  COMPARTMENT_SSCCID_PATTERN,
  EMAIL_PATTERN,
  NUMBER_PATTERN,
  INTEGER_NUMBER_PATTERN,
  PASSWORD_PATTERN,
  SSCCID_PATTERN,
  INTEGER_FRACTIONAL_NUMBER_PATTERN,
  NATURAL_NUMBER_PATTERN,
  FRACTIONAL_NUMBER_PATTERN,
  VEHICLE_ID_PATTERN,
  LOAD_NUMBER_PATTERN,
  FRACTIONAL_POSITIVE_NUMBER_PATTERN,
  NO_SPACE_INBETWEEN_PATTERN,
} from '../../common/constants/validation-rules';

export enum ErrorType {
  Pattern = 'pattern',
  PatternKey = 'patternKey',
  Max = 'max',
  Min = 'min',
  BoschEmail = 'boschEmail',
  DuplicateAddress = 'duplicateAddress',
}

export const PATTERN_TRANSLATION_KEY_MAP = new Map([
  [NUMBER_PATTERN.toString(), 'number'],
  [INTEGER_NUMBER_PATTERN.toString(), 'number'],
  [NATURAL_NUMBER_PATTERN.toString(), 'naturalNumbers'],
  [FRACTIONAL_POSITIVE_NUMBER_PATTERN.toString(), 'naturalNumbers'],
  [INTEGER_FRACTIONAL_NUMBER_PATTERN.toString(), 'number'],
  [COMPARTMENT_SSCCID_PATTERN.toString(), 'compartmentSsccId'],
  [EMAIL_PATTERN.toString(), 'email'],
  [PASSWORD_PATTERN.toString(), 'token'],
  [SSCCID_PATTERN.toString(), 'ssccId'],
  [PASSWORD_PATTERN.toString(), 'password'],
  [FRACTIONAL_NUMBER_PATTERN.toString(), 'number'],
  [VEHICLE_ID_PATTERN.toString(), 'vehicleId'],
  [LOAD_NUMBER_PATTERN.toString(), 'loadNumber'],
  [NO_SPACE_INBETWEEN_PATTERN.toString(), 'password'],
]);
